import { addDays } from 'date-fns';

// チケット返却可能期限を算出
export const calcTicketReturnDeadline = (startAt: Date): Date => {
  // HACK:
  // -1日というロジックをバック・フロント両方で持ってしまっているのでバックエンドに寄せたほうがいいかもしれないが、
  // 日付の計算だけをするとか、-1だけを返すようなAPIを作りはじめると大変なことになりそう
  return addDays(startAt, -1);
};
